import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube, Clock } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0B2B40] text-white/80">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets.emergentagent.com/job_rb-coaching-hub-1/artifacts/dkty72fa_logo.png"
              alt="RB InnerRise Coaching Academy logo"
              data-testid="footer-logo-img"
              className="h-20 w-20 object-cover rounded-lg"
              style={{ mixBlendMode: "screen" }}
            />
            <div>
              <div className="font-serif text-xl text-white">RB InnerRise Coaching Academy</div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">RBICA</div>
            </div>
          </div>
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">
            RB InnerRise Coaching Academy — Life Coach · Educator · Speaker.
            Helping people grow with confidence and purpose. Founded by Reza
            Behzad.
          </p>
          <p className="mt-4 font-serif italic text-white/75">
            “Keep learning, keep growing, keep dreaming.”
          </p>
          <div className="mt-6 flex gap-4">
            <a href="#" data-testid="social-instagram" className="hover:text-[#E8F0F8] transition-colors"><Instagram size={18} /></a>
            <a href="#" data-testid="social-linkedin" className="hover:text-[#E8F0F8] transition-colors"><Linkedin size={18} /></a>
            <a href="#" data-testid="social-youtube" className="hover:text-[#E8F0F8] transition-colors"><Youtube size={18} /></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.25em] uppercase text-white/50 mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><a href="/#about" className="hover:text-white">About</a></li>
            <li><a href="/#programs" className="hover:text-white">Programs & Pricing</a></li>
            <li><a href="/#retreats" className="hover:text-white">Retreats</a></li>
            <li><a href="/#mission" className="hover:text-white">Mission & Vision</a></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs tracking-[0.25em] uppercase text-white/50 mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li><a href="mailto:rbinnerrise@gmail.com" className="hover:text-white">rbinnerrise@gmail.com</a></li>
            <li><a href="tel:+12534134604" className="hover:text-white">+1 (253) 413-4604</a></li>
            <li>
              <a
                href="https://rbinnerrisecoachingacademy.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-website-link"
                className="hover:text-white"
              >
                RbInnerRiseCoachingAcademy.com
              </a>
            </li>
            <li><a href="/#discovery-call" className="hover:text-white">Free Discovery Call</a></li>
          </ul>

          <div className="mt-7 pt-6 border-t border-white/10">
            <div className="flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-white/50 mb-3">
              <Clock size={12} /> Business Hours
            </div>
            <ul className="text-sm space-y-1.5 text-white/75">
              <li>Mon–Fri · 6:00 PM – 9:00 PM</li>
              <li>Sat–Sun · 9:00 AM – 6:00 PM</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} RB InnerRise Coaching Academy. All rights reserved.</div>
          <div className="font-serif italic text-white/60">Rise from within.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
